export default __webpack_public_path__ + "static/character-13fa72eb0875f459c0830a1ce0a7d94b.png";